import { WHEEL_LOADER } from './dimensions';
import { WheelLoaderBody } from './WheelLoaderBody';
import { WHEEL_LOADER_LAYOUT, WHEEL_LOADER_WHEELS } from './wheels';

const wheelLoader4Preset = {
  id: 'wheel-loader-4-standard',
  silhouette: 'wheel_loader',
  renderModelKey: 'wheel_loader',
  renderLayoutKey: 'wheel_loader-4-wheel-v1',
  label: '2 axles, single fitment',
  layout: WHEEL_LOADER_LAYOUT,
  wheels: WHEEL_LOADER_WHEELS,
  camera: {
    position: [8.2, 4.5, 7.6],
    target: [0, 1.25, 0],
    minDistance: 5.5,
    maxDistance: 20,
    fov: 32,
  },
  stage: { extent: WHEEL_LOADER.length, contactHeight: 1.55 },
  skeleton: 'frame',
  Body: WheelLoaderBody,
};

export { wheelLoader4Preset };
